import {TabsWrapper as Component} from "components/common/tabs/tabs";
import {TabsRender} from "components/common/tabs/tabs.render";

export const Tabs = {
    Wrapper: Component,
    Outlet: TabsRender
}